module.exports = "../../app/cells/pages/landing_playground/index/about_cell.rb";